import { AreaChartOutlined } from "@ant-design/icons";
import { Button, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import monthlyPaidCol from "../component/monthlypaid/tableColumn/mondlyPaidColumn";
import AddReport from "../component/report/modal/addReport";
import FilterSummary from "../component/report/modal/filterSummary";
import SummaryReportPrint from "../component/report/modal/summaryReportPrint";
import { getMondlyPaidWithPagination } from "../function/fn";

export default function MonthlyPaid() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [loading, setLoading] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [, setSumAmount] = useState(0);

  const [success, setSuccess] = useState(false);

  const [openAdd, setOpenAdd] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [openSummary, setOpenSummary] = useState(false);

  //filter
  const [voidFilter, setVoidFilter] = useState(null);
  const [printData, setPrintData] = useState(null);

  async function fetchData() {
    let data = await getMondlyPaidWithPagination(page, pageSize, voidFilter);
    setDataList(data);
    setSumAmount(data?.sumAmount);
    setLoading(false);
    setSuccess(false);
  }

  useEffect(() => {
    setLoading(true);

    fetchData();
  }, [page, pageSize, success, voidFilter]);

  const handlePrint = (e) => {
    setPrintData(e);
    setOpenPrint(true);
  };

  const handleReset = () => {
    setVoidFilter(null);
  };

  let tableDataWithNo = [];

  dataList?.data?.forEach((record, index) => {
    let pageAdd = page > 1 ? page * pageSize - pageSize + 1 : 1;

    let data = { ...record, no: dataList?.totalDoc - (pageAdd + index) + 1 };
    tableDataWithNo.push(data);
  });

  return (
    <>
      <AddReport setOpen={setOpenAdd} open={openAdd} setSuccess={setSuccess} />
      <SummaryReportPrint
        setOpen={setOpenPrint}
        open={openPrint}
        month={printData?.month}
        year={printData?.year}
      />
      <FilterSummary
        open={openSummary}
        setOpen={setOpenSummary}
        setSuccess={setSuccess}
        isForPrint={true}
      />

      <Row>
        <Col xs={24} lg={24} style={{ padding: 10 }}>
          <h2>Report </h2>
        </Col>

        <Col xs={24} lg={5} style={{ padding: 10 }}>
          <Button
            size="large"
            onClick={() => setOpenSummary(true)}
            style={{ width: "100%" }}
          >
            <AreaChartOutlined style={{ fontSize: 15 }} />
            SALARY REPORT
          </Button>
        </Col>

        {/* <Col xs={24} lg={3} style={{ padding: '10px 5px' }}>
                    <Select placeholder="Void?" value={voidFilter} size="large" style={{ width: '100%' }} onChange={(e) => handleVoidFilter(e)}>
                        <Option key="all" value="">-- All --</Option>
                        <Option key="1" value="1">Voided</Option>
                        <Option key="0" value="0">Unvoided</Option>

                    </Select>
                </Col> */}

        <Col xs={24} lg={3} style={{ padding: "10px 5px" }}>
          {voidFilter ? (
            <Button
              size="large"
              style={{ width: "100%" }}
              className="reset-btn"
              onClick={() => handleReset()}
            >
              Reset
            </Button>
          ) : null}
        </Col>

        <Col xs={24} style={{ padding: 10 }}>
          <Table
            className="table-custom-list"
            columns={monthlyPaidCol({ handlePrint, setOpenAdd })}
            dataSource={loading ? [] : tableDataWithNo}
            rowKey={(record) => record?.mp_id}
            rowClassName={(record) =>
              parseInt(record?.void) > 0 ? "void-row" : ""
            }
            // onChange={handleTableChange}
            pagination={{
              size: "small",
              total: dataList?.totalDoc,
              pageSizeOptions: ["10", "20", "30", "50", "100", "200"],
              // showSizeChanger: true,
              pageSize: pageSize,
              // current: peopleData?.paginator?.currentPage,
              onChange: (page, pageSize) => {
                setPage(page);
                setPageSize(pageSize);
              },
            }}
            sticky
            scroll={{ x: 1200 }}
            loading={loading}
          />
        </Col>
      </Row>
    </>
  );
}
